import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

export enum InputThemes {
  default = 'default',
  concrete = 'concrete',
}

@Component({
  selector: 'sd-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class InputComponent {
  @Input() theme: InputThemes = InputThemes.default;

  @HostBinding('class')
  get classNames(): string[] {
    return ['sd-input', this.theme && `sd-input-theme-${this.theme}`].filter(Boolean);
  }
}
